import styled from 'styled-components';

export const TabContainer = styled.div`
  padding: 10px 0;
  background-color: var(--BackgroundLight);
`;

export const TabWrapper = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;

export const TabSpan = styled.span`
  font-size: 14px;
  margin-left: 5px;
  line-height: 23.68px;
  display: inline-flex;
  color: var(--DarkGray);
  letter-spacing: 0.78px;
  margin-right: 5px;

  &:hover {
    color: var(--ContrastGray);
  }
`;
